module.exports = __webpack_public_path__ + "static/img/xinjian.40d08a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinjian.png
// module id = zPvo
// module chunks = 0